import { render } from "./Test.vue?vue&type=template&id=5e18f844&scoped=true"
import script from "./Test.vue?vue&type=script&scope=true&lang=js"
export * from "./Test.vue?vue&type=script&scope=true&lang=js"

import "./Test.vue?vue&type=style&index=0&id=5e18f844&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e18f844"]])

export default __exports__